import { IGetEntregaObrasClienteByIdUseCase } from "../../../presentation/useCases/read/get_entrega_obras_cliente_by_id_use_case";
import { EntregaObraClienteChecklist } from "../../models/entrega_obra_cliente_checklist";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetEntregaObrasClienteByIdUseCase
 */

export class GetEntregaObrasClienteByIdUseCase implements IGetEntregaObrasClienteByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObraCliente: number): Promise<EntregaObraClienteChecklist> {
    return await this.repository.getEntregaObrasClienteChecklistById(idEntregaObraCliente);
  }
}
